import React from 'react';
import About from "./components/About/About";
import Admin from "./components/Admin/Admin";
import Comments from "./components/Comments/Comments";
import Content from "./components/Content/Content";
import Expos from "./components/Expos/Expos";
import Footer from "./components/Footer/Footer";
import Galleries from "./components/Galleries/Galleries";
import Home from "./components/Home/Home";
import Legal from "./components/Legal/Legal";
import Links from "./components/Links/Links";
import TopBar from "./components/TopBar/TopBar";
import {Route, BrowserRouter, Routes} from 'react-router-dom';
import './App.css';

function App() {

  return (
    <BrowserRouter>
      <div className="App">
        <TopBar />
        <Content>
          <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/galleries" element={<Galleries />}/>
            <Route path="/about" element={<About />}/>
            <Route path="/comments" element={<Comments />}/>
            <Route path="/legal" element={<Legal />}/>
            <Route path="/expos" element={<Expos />}/>
            <Route path="/links" element={<Links />}/>
            <Route path="/admin" element={<Admin />}/>
          </Routes>
        </Content>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
